import React from 'react';
import { Clock, ShieldAlert, X } from 'lucide-react';

const LookupLimitModal = ({ hoursRemaining, onClose }) => {
    return (
        <div 
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm"
            data-testid="lookup-limit-modal-overlay"
        >
            <div 
                className="bg-card border border-border rounded-xl shadow-2xl max-w-md w-full mx-4 p-6 md:p-8 relative"
                data-testid="lookup-limit-modal"
            >
                {/* Close button */}
                <button
                    onClick={onClose}
                    className="absolute top-4 right-4 p-1 rounded-lg hover:bg-muted transition-colors"
                    data-testid="lookup-limit-close-btn"
                >
                    <X className="h-5 w-5 text-muted-foreground" />
                </button>

                {/* Header */}
                <div className="flex items-center gap-3 mb-6">
                    <div className="w-12 h-12 rounded-full bg-amber-500/10 flex items-center justify-center">
                        <ShieldAlert className="w-6 h-6 text-amber-500" />
                    </div>
                    <h2 
                        className="text-xl md:text-2xl font-bold text-foreground"
                        data-testid="lookup-limit-modal-title"
                    >
                        Daily Lookup Limit Reached
                    </h2>
                </div>

                {/* Body */}
                <div className="mb-6">
                    <p 
                        className="text-muted-foreground leading-relaxed mb-4"
                        data-testid="lookup-limit-modal-body"
                    >
                        You've reached your daily lookup limit. This limit helps protect homeowner 
                        privacy and prevents misuse of the platform.
                    </p>
                    
                    <div className="flex items-center gap-3 p-4 bg-accent/30 rounded-lg">
                        <Clock className="h-5 w-5 text-primary flex-shrink-0" />
                        <p className="text-sm text-foreground">
                            Your limit resets in <span className="font-semibold text-primary">{hoursRemaining} hour{hoursRemaining !== 1 ? 's' : ''}</span>
                        </p>
                    </div>
                </div>

                {/* Button */}
                <button
                    onClick={onClose}
                    className="w-full py-3 px-4 bg-primary text-primary-foreground font-semibold rounded-lg hover:bg-primary/90 transition-colors"
                    data-testid="lookup-limit-ok-btn"
                >
                    I Understand
                </button>

                {/* Footer note */}
                <p className="mt-4 text-xs text-muted-foreground text-center">
                    ClientCheck limits lookups to 50 per day to ensure the platform is used responsibly.
                </p>
            </div>
        </div>
    );
};

export default LookupLimitModal;
